module.exports = __webpack_public_path__ + "static/media/animated_dinuka.f0017158.png";